import { render, staticRenderFns } from "./PlotRecommenderMonetizationType.vue?vue&type=template&id=0c391312"
import script from "./PlotRecommenderMonetizationType.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlotRecommenderMonetizationType.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports